// @ts-nocheck
import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import styled from 'styled-components'

export const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
`

type InnerProps = {
  hasLandingPageForm: boolean
}

export const Inner = styled.div<InnerProps>`
  min-height: 100vh;
  display: flex;
  ${({hasLandingPageForm}): string =>
    hasLandingPageForm ? 'padding-top: 64px' : 'align-items: center'};
`

const propTypes = {
  children: PropTypes.node.isRequired,
  hasLandingPageForm: PropTypes.bool.isRequired,
}
const defaultProps = {}

export type TopFoldWrapperProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const TopFoldWrapper: React.FC<TopFoldWrapperProps> = props => (
  <Wrapper>
    <Inner {...props} />
  </Wrapper>
)

TopFoldWrapper.propTypes = propTypes

TopFoldWrapper.defaultProps = defaultProps

export default TopFoldWrapper
